import SetColumnConfig from '../../../shared/components/grid/SetColumnConfig';
import { CalculateOpexValues } from './CalculateOpexValues';

export default function FinanceRepositorySetColumnConfig(props) {
  const { gridColumns: columnsConfig } = SetColumnConfig(props);
  const gridColumns = columnsConfig.reduce((resp, item) => {
    if (item.attrInternalName === 'nrp_o_self_funded') {
      item.onValueChange = (params) =>
        nrposelffundedOnChange({
          ...params,
          ...props.customProps,
        });
    } else if (item.attrInternalName === 'nrp_c_value') {
      item.onValueChange = (params) =>
        nrpcvalueOnChange({
          ...params,
          ...props.customProps,
        });
    } else if (item.attrInternalName === 'nrc_o_fai_val') {
      item.onValueChange = (params) =>
        CalculateOpexValues({
          ...params,
          ...props.customProps,
          changedCol: 'nrc_o_fai_val',
        });
    } else if (item.attrInternalName === 'nrc_o_me_val') {
      item.onValueChange = (params) =>
        CalculateOpexValues({
          ...params,
          ...props.customProps,
          changedCol: 'nrc_o_me_val',
        });
    } else if (item.attrInternalName === 'nrc_o_av_val') {
      item.onValueChange = (params) =>
        CalculateOpexValues({
          ...params,
          ...props.customProps,
          changedCol: 'nrc_o_av_val',
        });
    } else if (item.attrInternalName === 'nrp_o_fai_val') {
      item.onValueChange = (params) =>
        CalculateOpexValues({
          ...params,
          ...props.customProps,
          changedCol: 'nrp_o_fai_val',
        });
    } else if (item.attrInternalName === 'nrp_o_me_val') {
      item.onValueChange = (params) =>
        CalculateOpexValues({
          ...params,
          ...props.customProps,
          changedCol: 'nrp_o_me_val',
        });
    } else if (item.attrInternalName === 'nrp_o_av_val') {
      item.onValueChange = (params) =>
        CalculateOpexValues({
          ...params,
          ...props.customProps,
          changedCol: 'nrp_o_av_val',
        });
    } else if (
      item.attrInternalName === 'nrp_c_self_funded' ||
      item.attrInternalName === 'capex_file_updated'
    ) {
      item.onValueChange = (params) =>
        nrpcselffundedOnChange({
          ...params,
          ...props.customProps,
        });
    } else if (
      item.attrInternalName === 'nrp_o_as_po_num' ||
      item.attrInternalName === 'nrp_o_as_com_rec_offer_num' ||
      item.attrInternalName === 'nrp_o_s_com_offer_num'
    ) {
      item.onValueChange = (params) =>
        nrpoasponumOnChange({
          ...params,
          ...props.customProps,
        });
    }
    resp.push(item);
    return resp;
  }, []);
  return {
    gridColumns,
  };
}
export const nrposelffundedOnChange = (props) => {
  const { rowId, value, updateRow } = props;
  let updatedFields = {
    nrp_o_s_btp_com_offer: 'yes',
    nrp_o_s_other_com_offer: 'yes',
    nrp_o_s_com_offer_num: 'yes',
    nrp_o_state: 'no',
  };
  if (value === 'yes') {
    updatedFields = {
      nrp_o_s_btp_com_offer: 'no',
      nrp_o_s_other_com_offer: 'no',
      nrp_o_s_com_offer_num: 'no',
      nrp_o_state: 'yes',
    };
  }
  updateRow({
    rowId,
    updatedFields,
  });
};
export const nrpcvalueOnChange = async (props) => {
  const { rowId, value, row, updateRow } = props;
  const nrcOFaiVal = row.nrc_o_fai_val ? Number(row.nrc_o_fai_val) : 0;
  const nrcOMeVal = row.nrc_o_me_val ? Number(row.nrc_o_me_val) : 0;
  const nrcOAvVal = row.nrc_o_av_val ? Number(row.nrc_o_av_val) : 0;
  const sum = (nrcOFaiVal + nrcOMeVal + nrcOAvVal + Number(value)) * row?.exchange_rate;
  let updatedFields = {
    nrp_c_state: 'no',
    nrp_o_buy_ipa_val: Number(sum),
  };
  if (value == 0) {
    updatedFields = {
      nrp_c_state: 'yes',
      nrp_o_buy_ipa_val: Number(sum),
    };
  }
  updateRow({
    rowId,
    updatedFields,
  });
};
const nrpcselffundedOnChange = (props) => {
  const { rowId, value, updateRow } = props;
  let updatedFields = {
    nrp_c_state: 'no',
  };
  if (value == 'yes') {
    updatedFields = {
      nrp_c_state: 'yes',
    };
  }
  updateRow({
    rowId,
    updatedFields,
  });
};
const nrpoasponumOnChange = (props) => {
  const { rowId, value, updateRow } = props;
  let updatedFields = {
    nrp_o_state: 'no',
  };
  if (value) {
    updatedFields = {
      nrp_o_state: 'yes',
    };
  }
  updateRow({
    rowId,
    updatedFields,
  });
};
